import tw, { styled } from 'twin.macro';
import Input from '../Input/Input';

export const StyledInput = styled(Input)`
  ${tw`hidden`}
`;
